import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {
 
  constructor() { }

  ngOnInit() {
   // this.getAll();
  }
 
}



// WEBPACK FOOTER //
// ./src/app/components/integrations/integrations.component.ts